import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Cookie } from "lucide-react";

export function CookieConsent() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      setShow(!localStorage.getItem("cookie_consent"));
    } catch {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  const accept = () => {
    try {
      localStorage.setItem("cookie_consent", "1");
    } catch {
      /* storage unavailable */
    }
    setShow(false);
  };

  return (
    <div data-testid="cookie-consent-bar" className="fixed bottom-0 inset-x-0 z-[60] bg-slate-900/95 backdrop-blur border-t border-slate-800 px-4 py-3">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-3 sm:justify-between text-center sm:text-left">
        <p className="text-sm text-slate-300 flex items-center gap-2 flex-wrap justify-center">
          <Cookie className="w-4 h-4 text-blue-400 shrink-0" />
          We use essential cookies to keep you signed in and remember your preferences.
          <button data-testid="cookie-learn-more" onClick={() => navigate("/cookies")} className="underline hover:text-blue-400 transition-colors">Learn more</button>
        </p>
        <button data-testid="cookie-accept-button" onClick={accept} className="shrink-0 rounded-full bg-blue-600 hover:bg-blue-500 px-6 py-2 text-sm font-semibold text-white transition-colors">
          Accept
        </button>
      </div>
    </div>
  );
}
